import { render, staticRenderFns } from "./HeaderDesktop.vue?vue&type=template&id=3de07d62&scoped=true"
import script from "./HeaderDesktop.vue?vue&type=script&lang=js"
export * from "./HeaderDesktop.vue?vue&type=script&lang=js"
import style0 from "./HeaderDesktop.vue?vue&type=style&index=0&id=3de07d62&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de07d62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3de07d62')) {
      api.createRecord('3de07d62', component.options)
    } else {
      api.reload('3de07d62', component.options)
    }
    module.hot.accept("./HeaderDesktop.vue?vue&type=template&id=3de07d62&scoped=true", function () {
      api.rerender('3de07d62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HeaderDesktop.vue"
export default component.exports